import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import useTheme from "./useTheme";
import Modal from "react-bootstrap/Modal";

const VitrinMessage = (props) => {
  const [messageInput, setMessageInput] = useState("");

  const [message, setMessage] = useState("");

  const [res, setRes] = useState("");

  const [showMessage, setShowMessage] = useState(false);

  const [showRes, setShowRes] = useState(false);

  const [theme, switchTheme] = useTheme();

  useEffect(() => {
    const form = new FormData();
    form.append("getVitrinMessage", 1);
    form.append("vitrinCode", props.vitrinCode);
    const requ = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(requ)
      .then((res) => res.json())
      .then((data) => {
        setMessage(data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [res]);

  const messageHandle = (e) => {
    setMessageInput(e.target.value);
  };

  const submit = () => {
    const form = new FormData();
    form.append("setVitrinMessage", 1);
    form.append("vitrinCode", props.vitrinCode);
    form.append("message", messageInput);
    const requ = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(requ)
      .then((res) => res.json())
      .then((data) => {
        setShowRes(true);
        setRes(data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const deleteMessage = () => {
    const form = new FormData();
    form.append("setVitrinMessage", 1);
    form.append("vitrinCode", props.vitrinCode);
    form.append("message", "");
    const requ = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(requ)
      .then((res) => res.json())
      .then((data) => {
        setShowRes(true);
        setRes(data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  if (props.type === "marquee") {
    return (
      <>
        {message !== "" ? (
          <div className="mt-4">
            <div className="alert alert-success" role="alert">
              <strong>
                <marquee direction="right">{message} </marquee>
              </strong>
            </div>
          </div>
        ) : null}
      </>
    );
  } else {
    return (
      <>
        <Nav.Link
          onClick={() => {
            setShowMessage(true);
          }}
          href="#"
          className={theme === "light" ? "text-dark" : "text-light"}
        >
          جمله تبلیغاتی
        </Nav.Link>
        <Modal
          show={showMessage}
          onHide={() => setShowMessage(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          >
            جمله تبلیغاتی
          </Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <textarea
              className={"form-control text-center rtl"}
              placeholder="جمله تبلیغاتی"
              value={messageInput}
              onChange={messageHandle}
            ></textarea>
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-dark"
              onClick={() => setShowMessage(false)}
            >
              بستن
            </button>
            {message !== "" ? (
              <button
                className="btn btn-danger"
                onClick={() => deleteMessage()}
              >
                حذف جمله فعلی
              </button>
            ) : null}
            <button className="btn btn-success" onClick={() => submit()}>
              ثبت
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showRes}
          onHide={() => {
            setShowMessage(false);
            setShowRes(false);
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header
            className={
              theme === "light"
                ? "bg-light text-dark rtl justify-content-center"
                : "rtl justify-content-center bg-dark text-light"
            }
          ></Modal.Header>
          <Modal.Body
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            {res}
          </Modal.Body>
          <Modal.Footer
            className={
              theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
            }
          >
            <button
              className="btn btn-dark"
              onClick={() => {
                setShowMessage(false);
                setShowRes(false);
              }}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
};

export default VitrinMessage;
